import React from 'react'
import { connect } from 'react-redux'
import Component from '../common/Component'
import { benefitLabels, coverageTierLabels, deductibleMoopLabels, metadatumFieldsDiffSet } from './dentalFields'
import publishingActions from '../../actions/BenefitsSetsExportPublishings'
import BenefitsSetExportShow from '../BenefitsSet/BenefitsSetExportShow'

export class DentalBenefitsSetExportShow extends Component {
  static defaultFields = [
    'id',
    'vericred_id',
    'approval_state',
    'publish_state',
    'name',
    'audience',
    'plan_type',
    'plan_years',
    'stand_alone',
    'voluntary',
    'ortho',
    'source',
    'issuer_identifier',
    'issuer_name'
  ]

  render() {
    return (
      <BenefitsSetExportShow
        productLine="Dental"
        benefitLabels={({ ...benefitLabels, ...coverageTierLabels, ...deductibleMoopLabels })}
        benefitLabelsWithoutCoverageTier={({ ...coverageTierLabels, ...deductibleMoopLabels })}
        metadatumFieldsDiffSet={metadatumFieldsDiffSet}
        defaultFields={DentalBenefitsSetExportShow.defaultFields}
        benefitsSetUrl="/dental_benefits"
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    exportPublish: state.benefitsSetsExportPublishings.create
  }
}

const mapDispatchToProps = {
  createExportPublish: publishingActions.create.main,
  resetCreateExportPublish: publishingActions.create.reset
}

export default connect(mapStateToProps, mapDispatchToProps)(DentalBenefitsSetExportShow)
